module.exports = "https://99designs-start-assets.imgix.net/js/d04e6daee334e250e650aacf3e1345c4.png";